import React from 'react';
import PropTypes from 'prop-types';
import { TextField } from '@mui/material';

function DebouncedInput({ value: initialValue, onChange, debounce, sx, ...rest }) {
	const [value, setValue] = React.useState(initialValue);

	React.useEffect(() => {
		setValue(initialValue);
	}, [initialValue]);

	React.useEffect(() => {
		const timeout = setTimeout(() => {
			if (`${value}` !== `${initialValue}`) onChange(value);
		}, debounce);

		return () => clearTimeout(timeout);
	}, [debounce, initialValue, onChange, value]);

	return (
		<TextField
			sx={{ ...sx }}
			margin="dense"
			variant="outlined"
			value={value}
			onChange={(e) => setValue(e.target.value)}
			{...rest}
		/>
	);
}

DebouncedInput.propTypes = {
	value: PropTypes.any,
	onChange: PropTypes.func.isRequired,
	debounce: PropTypes.number,
	sx: PropTypes.object,
};

DebouncedInput.defaultProps = {
	debounce: 500,
	sx: {},
};

export default DebouncedInput;
